import React from 'react';

const BottomUXSpace = ({ size = 16 }) => {
    return (
        <div className={`h-${size}`}>

        </div>
    );
};

export default BottomUXSpace;